import { colors } from 'spw-theme';
import styled from 'styled-components';

export const EmptyStateText = styled.span`
  && {
    color: ${colors.fontColor};
  }
`;
